'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'brush';
var width = 384;
var height = 512;
var aliases = [];
var unicode = 'f55d';
var svgPathData = 'M128 368l-16 0-96 0L0 368l0-16L0 16 0 0 16 0 368 0l16 0 0 16 0 336 0 16-16 0-96 0-16 0 0 16 0 112 0 16-16 0-96 0-16 0 0-16 0-112 0-16zm0-16l16 0 0 16 0 128 96 0 0-128 0-16 16 0 112 0 0-80L16 272l0 80 112 0zm240-96l0-240-96 0 0 88 0 8-16 0 0-8 0-88-64 0 0 72 0 8-16 0 0-8 0-72L96 16l0 104 0 8-16 0 0-8L80 16 16 16l0 240 352 0zM176 448a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBrush = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;